export default __webpack_public_path__ + "static/media/BackgroundResetPassword.6203fc13.svg";